import { createContext, useContext } from 'react';
import { WrappedFormUtils } from '@ant-design/compatible/lib/form/Form';

export const FormContext = createContext<WrappedFormUtils | null>(null);
export const useFormContext = () => useContext(FormContext);
